var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41893 0.5C8.26194 0.5 8.10653 0.531368 7.9618 0.592262C7.81801 0.652778 7.68765 0.741241 7.57831 0.852513L1.10575 7.29365C1.0577 7.34147 1.02284 7.40091 1.00456 7.46619L0.0145592 11.0019C-0.0237091 11.1386 0.0147157 11.2852 0.115074 11.3857C0.215433 11.486 0.36212 11.5244 0.498793 11.4862L4.03451 10.4962C4.09979 10.4778 4.15923 10.443 4.20704 10.395L10.6481 3.92247L10.6492 3.92141C10.7591 3.81207 10.8464 3.68209 10.906 3.53894C10.9659 3.39532 10.9967 3.24128 10.9967 3.08569C10.9967 2.9301 10.9659 2.77605 10.906 2.63243C10.8464 2.48928 10.7591 2.3593 10.6492 2.24996L10.6481 2.2489L9.26035 0.853334C9.1509 0.741676 9.02024 0.652926 8.87606 0.592262C8.73133 0.531368 8.57592 0.5 8.41893 0.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg47);
export default __webpack_public_path__ + "static/media/svg47.073b018a67320e336d1cc3f4dd4dc247.svg";
export { ForwardRef as ReactComponent };